export enum FilterOperation {
  Equal = 'Equal',
  NotEqual = 'NotEqual',
  GreaterThan = 'GreaterThan',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  Between = 'Between',
  Like = 'Like'
}

export interface FilterProp<T = any> {
  Operator: FilterOperation | keyof typeof FilterOperation;
  Values: T[];
}

export const isFilterProp = (filterProp: any): filterProp is FilterProp => {
  const keys = Object.keys(filterProp);
  return keys.includes('Operator') || keys.includes('Values');
};
